import {createStore, combineStateUpdaters } from "./dataStore";
import stateUpdaters from './actions';
import * as koDataProvider from './ko-dataStore';

const appStore = createStore(combineStateUpdaters(stateUpdaters));
koDataProvider.applyStoreToContext(appStore); // sets up the ko bindingProvider instance
